// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.00774 21.0014H2V14.9956L7.00774 9.979V21.0014Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 21.0065H16.9923V9.91893L22 4.00193V21.0065Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.51717 3.99316L2.99447 3.99318L12.8191 13.2574L16.1576 9.91893L9.51717 3.99316Z"}}]};

const LogoXiaomareportFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-xiaomareport-filled',
    ref,
    icon: element,
  },
));

LogoXiaomareportFilledIcon.displayName = 'LogoXiaomareportFilledIcon';

export default LogoXiaomareportFilledIcon;
